/**
 * Readable form of a stored number for rep-facing copy (toasts first; the Trellus bulk toast and any later
 * surface reuse it). `+1 201 320 9233` for a US/Canada number, `201 320 9233` for ten bare digits, anything
 * else as given. Pure and browser-safe (imported by the frontend via `@shared`), sibling of `normalize-phone.ts`.
 */
export function formatPhoneForDisplay(value: string): string {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  }
  if (digits.length === 10 && !trimmed.startsWith('+')) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }
  return trimmed;
}
